// extracted by mini-css-extract-plugin
export default {"defaultImageContainer":"DefaultImg_defaultImageContainer__ShjlA","defaultImageContent":"DefaultImg_defaultImageContent__x0QQI"};